// idModulo -> ruta del front. Un modulo sin ruta se muestra en /modulos pero no navega.
export const MODULE_ROUTES = {
  1: "/facturacion",
  5: "/sistema-contable",
};
